export default __webpack_public_path__ + "static/media/SurfaceDock.30d1eb1a.svg";